<template>
  <!-- 社会功能开发课 -->
  <div class="shehuigongnengkaifake">
    <PublicCert :logo="Logo11" :type="'jy-sf'" :color="'#294db0'" />
  </div>
</template>

<script>
import PublicCert from '../component/certQuery.vue'
import Logo11 from '@/assets/images/logo11.png'

export default {
  name: 'SheHuiGongNengKaiFa',
  components: {
    PublicCert
  },
  data() {
    return {
      Logo11
    }
  }
}
</script>
